// extracted by mini-css-extract-plugin
export default {"headline":"styles_headline__oTNs8","title":"styles_title__B7Z0i","divider":"styles_divider__4sKah","subTitle":"styles_subTitle__Bfcgh"};